import type { FC } from "react";
import { Link } from "react-router-dom";

import { AppStrings } from "../../utils/constants/AppStrings";
import { REGULATOR_PORTAL_DASHBOARD_ROUTE } from "./regulatorPortalRoutes";

import styles from "./RegulatorPortalScreen.module.css";

/**
 * Unknown `/regulator-portal/*` paths land here instead of the global
 * catch-all, which would bounce a signed-in regulator to the staff login.
 */
const RegulatorPortalNotFound: FC = () => (
  <div className={styles.screen} data-testid="regulator-portal-not-found">
    <h1 className={styles.title}>
      {AppStrings.PAM_REGULATOR_PORTAL_NOT_FOUND_TITLE}
    </h1>
    <p className={styles.body}>
      {AppStrings.PAM_REGULATOR_PORTAL_NOT_FOUND_BODY}
    </p>
    <div className={styles.actions}>
      <Link to={REGULATOR_PORTAL_DASHBOARD_ROUTE}>
        {AppStrings.PAM_REGULATOR_PORTAL_BACK_TO_DASHBOARD}
      </Link>
    </div>
  </div>
);

export default RegulatorPortalNotFound;
